export function shouldLoadGtm(config: { enabled: boolean; webContainerId: string; policyVersion: string },
  consent: { analytics: boolean; advertising: boolean; policyVersion: string } | null) {
  return Boolean(config.enabled && config.webContainerId && consent &&
    consent.policyVersion === config.policyVersion && (consent.analytics || consent.advertising))
}
export const measurementEventNames = ["page_view", "outbound_booking_click", "telephone_click",
  "lead_created", "quote_issued", "checkout_started", "purchase"] as const
export type MeasurementEventName = typeof measurementEventNames[number]
export const defaultMeasurementEvents: Record<MeasurementEventName, boolean> = {
  page_view: true, outbound_booking_click: true, telephone_click: true,
  lead_created: true, quote_issued: true, checkout_started: true, purchase: true,
}
const unlocalizedPath = (path: string) => path.replace(/^\/(?:en|es)(?=\/)/, "")
export function isSensitiveMeasurementPath(path: string) {
  const clean = unlocalizedPath(path)
  if (/^\/shop\/(?:orders|verify|checkout)(?:\/|$)/.test(clean)) return true
  return /^(?:\/(?:document|group-pay|account|admin|crm|my|events|trip|unsubscribe|manage-reservation|appointments|content-preview))(?:\/|$)/.test(clean) ||
    /^\/reserve\/(?:quote|payment)\//.test(clean)
}
export function sanitizedMeasurementPath(path: string) {
  const clean = unlocalizedPath(path)
  if (/^\/shop\/(?:orders|verify|checkout)(?:\/|$)/.test(clean)) return "/shop/private/"
  const privateArea = /^(\/(?:document|group-pay|account|admin|crm|my|events|trip|unsubscribe|manage-reservation|appointments|content-preview))(?:\/|$)/.exec(clean)
  if (privateArea) return privateArea[1] + "/"
  if (/^\/reserve\/(?:quote|payment)\//.test(clean)) return "/reserve/"
  return clean
}
